import { useRef, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

/* HTML5 drag-and-drop reordering persisted via PUT /admin/reorder/{collection} */
export function useDragReorder({ items, setItems, collection, enabled = true }) {
    const dragIndex = useRef(null);
    const [draggingIndex, setDraggingIndex] = useState(null);
    const [overIndex, setOverIndex] = useState(null);

    async function persist(newItems) {
        try {
            await api.put(`/admin/reorder/${collection}`, { ids: newItems.map((i) => i.id) });
            toast.success("Ordem guardada");
        } catch {
            toast.error("Erro ao guardar a ordem");
        }
    }

    function dragProps(index) {
        if (!enabled) return {};
        return {
            draggable: true,
            onDragStart: (e) => {
                dragIndex.current = index;
                setDraggingIndex(index);
                e.dataTransfer.effectAllowed = "move";
            },
            onDragOver: (e) => {
                e.preventDefault();
                e.dataTransfer.dropEffect = "move";
                if (overIndex !== index) setOverIndex(index);
            },
            onDragLeave: () => setOverIndex((v) => (v === index ? null : v)),
            onDrop: (e) => {
                e.preventDefault();
                const from = dragIndex.current;
                setDraggingIndex(null);
                setOverIndex(null);
                if (from == null || from === index) return;
                const copy = [...items];
                const [moved] = copy.splice(from, 1);
                copy.splice(index, 0, moved);
                const renumbered = copy.map((it, i) => ({ ...it, order: i + 1 }));
                setItems(renumbered);
                persist(renumbered);
            },
            onDragEnd: () => {
                setDraggingIndex(null);
                setOverIndex(null);
            },
        };
    }

    return { dragProps, draggingIndex, overIndex };
}
